module.exports = __webpack_public_path__ + "img/auth-img-1.9d7715b0.svg";